import details from './details/DetailsReducer';
import addresses from './addresses/AddressesReducer';

const initialState = { details: {}, addresses: {} };

const account = (state = initialState, action) => ({
  ...state,
  details: details(state.details, action),
  addresses: addresses(state.addresses, action),
});

export default account;
